import { render, staticRenderFns } from "./partnerGoods.vue?vue&type=template&id=346fa392&scoped=true"
import script from "./partnerGoods.vue?vue&type=script&lang=js"
export * from "./partnerGoods.vue?vue&type=script&lang=js"
import style0 from "./partnerGoods.vue?vue&type=style&index=0&id=346fa392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fa392",
  null
  
)

export default component.exports